/**
 * API Configuration Module
 * Centralized configuration for all API endpoints and settings
 */

// Load and validate environment variables
const loadConfig = () => {
  const config = {
    // API Base Configuration
    baseURL: process.env.REACT_APP_API_BASE_URL,
    apiKey: process.env.REACT_APP_API_KEY,
    
    // Request Configuration
    timeout: parseInt(process.env.REACT_APP_REQUEST_TIMEOUT) || 30000,
    retryAttempts: parseInt(process.env.REACT_APP_RETRY_ATTEMPTS) || 3,
    
    // Debug Configuration
    debugMode: process.env.REACT_APP_DEBUG_API === 'true',
    
    // API Endpoints
    endpoints: {
      dashboardCounts: '/api/v1/analytics/dashboard-counts',
      health: '/health',
      // Film Comps API Endpoints
      filmComps: {
        getFilmComps: '/api/v1/comps/films/{filmId}/comps',
        getComparisonData: '/api/v1/comps/compare/{filmId}',
        getCandidates: '/api/v1/comps/candidates/{filmId}',
        assignComp: '/api/v1/comps/greenlight/assign',
        updateComp: '/api/v1/comps/greenlight/{compId}',
        deleteComp: '/api/v1/comps/{compId}',
        bulkAssign: '/api/v1/comps/bulk-assign',
        getAnalytics: '/api/v1/comps/analytics/summary',
        getCompHistory: '/api/v1/comps/history/{compId}'
      },
      // Box Office Projections API Endpoints
      boxOfficeProjections: {
        createProjection: '/api/v1/box-office-projections',
        getProjections: '/api/v1/box-office-projections',
        getProjection: '/api/v1/box-office-projections/{projectionId}',
        getFilmProjections: '/api/v1/box-office-projections/films/{filmId}',
        updateProjection: '/api/v1/box-office-projections/{projectionId}',
        deleteProjection: '/api/v1/box-office-projections/{projectionId}'
      }
    }
  };

  // Validation
  if (!config.baseURL) {
    console.error('❌ REACT_APP_API_BASE_URL is required but not set');
    throw new Error('API base URL is not configured');
  }

  if (!config.apiKey) {
    console.error('❌ REACT_APP_API_KEY is required but not set');
    throw new Error('API key is not configured');
  }

  // Validate URL format
  try {
    new URL(config.baseURL);
  } catch (error) {
    console.error('❌ Invalid API base URL format:', config.baseURL);
    throw new Error('Invalid API base URL format');
  }

  if (config.debugMode) {
    console.log('🔧 API Configuration loaded:', {
      baseURL: config.baseURL,
      timeout: config.timeout,
      retryAttempts: config.retryAttempts,
      debugMode: config.debugMode,
      apiKeySet: !!config.apiKey
    });
  }

  return config;
};

// Export validated configuration
export const apiConfig = loadConfig();

// Export individual components for convenience
export const {
  baseURL,
  apiKey,
  timeout,
  retryAttempts,
  debugMode,
  endpoints
} = apiConfig;

export default apiConfig;
